// import { ApiService } from '@/services/bricmate/ApiService';
import { ApiService2 } from "@/services/bricmate/ApiService2";

import { orderCatalog } from "@/models/bricmate/orderCatalog";
import ThankYouModal from "./ThankYouModal.vue";
import { extend } from "vee-validate";

const emptyOrderForm = (): orderCatalog => ({
    firstname: "",
    lastname: "",
    address: "",
    email: "",
    phonenumber: "",
    postalcode: "",
    city: "",
    optionGroup1Question: "",
    optionGroup1Selection: [],
    optionGroup2Question: "",
    optionGroup2Selection: [],
    optionGroup3Question: "",
    optionGroup3Selection: [],
    optionGroup4Question: "",
    optionGroup4Selection: [],
});

export default {
    name: "CatalogForm",
    data() {
        return {
            orderForm: emptyOrderForm(),
            showThankYouModal: false,
        };
    },
    props: ["viewmodel"],
    components: {
        ThankYouModal,
    },
    computed: {
        translations() {
            return window.__litium.translation;
        },
    },
    created() {
        const phoneRegex = /^(?:\+|00)?[\d\s-]{7,15}$/;
        const postalCodeRegex = /^(\d{4}|\d{3}\s?\d{2})$/;

        extend("validPhone", {
            validate: value => phoneRegex.test(value),
        });

        extend("postalCode", {
            validate: value => postalCodeRegex.test(value),
        });
    },
    methods: {
        onSubmit() {
            const self = this;
            [1, 2, 3, 4].forEach(groupNumber => {
                const key = `optionGroup${groupNumber}Selection` as keyof typeof self.orderForm;
                if (typeof self.orderForm[key] === "string") self.orderForm[key] = [self.orderForm[key]];
            });

            // Set questions from viewmodel dynamically
            for (let i = 1; i <= 4; i++) {
                const field = `optionGroup${i}Question`;

                if (this.viewmodel[field]) {
                    this.orderForm[field] = this.viewmodel[field];
                }
            }

            ApiService2.orderCatalog(this.orderForm).then(response => {
                if (response && response.status == 200) {
                    this.showThankYouModal = true;
                }
            });
            this.resetForm();
        },
        resetForm() {
            this.orderForm = emptyOrderForm();

            this.$nextTick(() => this.$refs.observer.reset());
        },
        handleCloseModal() {
            this.showThankYouModal = false;
        },
    },
};
